import dayjs from 'dayjs';
import type { WordTrackChangeRevisionData } from './types';
import { Mark, mergeAttributes } from '@tiptap/core';

export const MARK_INSERT_REVISION = 'insertRevision';

// 삽입 리비전 마크
const InsertRevision = Mark.create({
    name: MARK_INSERT_REVISION,
    addAttributes() {
        // https://github.com/ueberdosis/tiptap/issues/2661
        // 처음에 아이디 한개를 만들어낼뿐 실제로 매번 새 ID가 부여되진않음
        const defaultRevision: WordTrackChangeRevisionData = {
            id: crypto.randomUUID(),
            authorInfo: {
                id: null,
                displayName: 'Unnamed',
            },
            createdAt: dayjs().toISOString(),
        };
        return {
            revision: {
                default: defaultRevision,
                parseHTML: element => JSON.parse(element.dataset.revision || 'null') || defaultRevision,
                renderHTML: attributes => {
                    return {
                        'data-revision': JSON.stringify(attributes.revision),
                    };
                },
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'span[data-insert-revision]',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', mergeAttributes(HTMLAttributes, { 'data-insert-revision': '' }), 0];
    },
});

export default InsertRevision;
